import script from "./Sula-Webshop-Orders.vue?vue&type=script&setup=true&lang=js"
export * from "./Sula-Webshop-Orders.vue?vue&type=script&setup=true&lang=js"

import "./Sula-Webshop-Orders.vue?vue&type=style&index=0&id=5b210a9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b210a9c"]])

export default __exports__